import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/SearchCars'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class SearchCarsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "SearchCarsStore",
			variables: true,
		})
	}
}

export async function load_SearchCars(params) {
  await initClient()

	const store = new SearchCarsStore()

	await store.fetch(params)

	return {
		SearchCars: store,
	}
}
